import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Button, Modal, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';
const BASE_API_URL = process.env.REACT_APP_API_URL;

const EmailCampaignList = () => {
    const [campaigns, setCampaigns] = useState([]);
    const [showContentModal, setShowContentModal] = useState(false);
    const [selectedContent, setSelectedContent] = useState("");

    const fetchCampaigns = async () => {
        try {
            const res = await axios.get(`${BASE_API_URL}/campaigns/all`);
            setCampaigns(res.data);
        } catch (err) {
            console.error("Fetch campaigns error:", err);
        }
    };

    // fetch campaigns on component mount
    useEffect(() => {
        fetchCampaigns();
    }, []);


    const handleViewClick = (content) => {
        setSelectedContent(content);
        setShowContentModal(true);
    };

    const handleClose = () => {
        setShowContentModal(false);
        setSelectedContent("");
    };
    const handleDeleteCampaign = async (id) => {

        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You want to delete this campaign!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel"
        });

        if (!result.isConfirmed) return;

        try {
            await axios.delete(`${BASE_API_URL}/campaigns/delete/${id}`);

            Swal.fire({
                title: "Deleted!",
                text: "Campaign has been deleted.",
                icon: "success",
                timer: 1500,
                showConfirmButton: false
            });

            fetchCampaigns(); // refresh table

        } catch (err) {
            console.error("Delete campaign error:", err);

            Swal.fire({
                title: "Error!",
                text: "Failed to delete campaign.",
                icon: "error"
            });
        }
    };
    const handlePause = async (id) => {
        try {
            await axios.put(`${BASE_API_URL}/campaign/pause/${id}`);
            fetchCampaigns();
        } catch (err) {
            console.error("Pause error:", err);
        }
    };

    const handleResume = async (id) => {
        try {
            await axios.put(`${BASE_API_URL}/campaign/resume/${id}`);
            fetchCampaigns();
        } catch (err) {
            console.error("Resume error:", err);
        }
    };
    return (
        <div className="p-3 border rounded bg-light">

            <Table striped bordered hover responsive className="mt-3">
                <thead className="table-dark">
                    <tr>
                        <th>Name</th>
                        <th>From Email</th>
                        <th>Email List</th>
                        <th>Email Content</th>
                        <th>Date</th>
                        <th>Interval</th>
                        <th>Status</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {campaigns.length === 0 ? (
                        <tr>
                            <td colSpan={5} className="text-center">No campaigns found</td>
                        </tr>
                    ) : (
                        campaigns.map((c) => (
                            <tr key={c.id}>
                                <td>{c.name}</td>
                                <td>{c.fromEmail}</td>
                                <td>{c.emailListName}</td>
                                <td>
                                    <Button
                                        variant="info"
                                        size="sm"
                                        onClick={() => handleViewClick(c.emailContent)}
                                    >
                                        View
                                    </Button>
                                </td>
                                <td>{c.scheduledDate}</td>
                                <td>{c.emailsPerHour} emails / hour</td>
                                <td>
                                    <span className={
                                        `badge ${c.status === "RUNNING" ? "bg-success" :
                                            c.status === "PAUSED" ? "bg-warning text-dark" :
                                                "bg-secondary"
                                        }`
                                    }>
                                        {c.status}
                                    </span>
                                </td>
                                {/* ✅ Action Column */}
                                <td>
                                    <div className="d-flex gap-2">

                                        {/* ▶️ Resume */}
                                        {c.status === "PAUSED" && (
                                            <Button
                                                variant="success"
                                                size="sm"
                                                onClick={() => handleResume(c.id)}
                                            >
                                                ▶ Resume
                                            </Button>
                                        )}

                                        {/* ⏸ Pause */}
                                        {c.status === "RUNNING" && (
                                            <Button
                                                variant="warning"
                                                size="sm"
                                                onClick={() => handlePause(c.id)}
                                            >
                                                ⏸ Pause
                                            </Button>
                                        )}

                                        {/* 🗑 Delete */}
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => handleDeleteCampaign(c.id)}
                                        >
                                            🗑 Delete
                                        </Button>

                                    </div>
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>
            {/* Modal to display full Email Content */}
            <Modal
                show={showContentModal}
                onHide={handleClose}
                size="lg"
                scrollable
            >
                <Modal.Header closeButton>
                    <Modal.Title>Email Content</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div
                        dangerouslySetInnerHTML={{ __html: selectedContent }}
                        style={{ minHeight: "200px" }}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>

    )
}

export default EmailCampaignList